import { render, staticRenderFns } from "./mainSub.vue?vue&type=template&id=6f21446c"
import script from "./mainSub.vue?vue&type=script&lang=js"
export * from "./mainSub.vue?vue&type=script&lang=js"
import style0 from "./mainSub.vue?vue&type=style&index=0&id=6f21446c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports